module.exports = __webpack_public_path__ + "static/media/YB5F12_9.49dbd0b1.jpg";